import { useParams, Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";

const PAGES = {
  privacidade: {
    title: "Política de Privacidade",
    body: [
      "Esta página tem como único objetivo apresentar o e-book digital “Meu Ex de Volta — 50 Simpatias para Reconquistar um Amor”.",
      "Não coletamos dados pessoais neste site. Dados de pagamento e de entrega são tratados exclusivamente pela plataforma Monetizze, responsável pelo processamento da compra, conforme os termos e a política de privacidade da própria plataforma.",
      "Com o seu consentimento, este site pode utilizar cookies e identificadores de rastreamento (como Meta Pixel e Google Ads) para medir audiência e o desempenho de campanhas. Você pode aceitar ou recusar esse uso no aviso de cookies e limpar os cookies do seu navegador a qualquer momento.",
      "Em caso de dúvidas sobre privacidade, utilize o canal de contato informado nesta página.",
    ],
  },
  termos: {
    title: "Termos de Uso",
    body: [
      "Ao acessar esta página, você concorda com estes termos. O conteúdo apresentado refere-se a um e-book digital de caráter cultural, simbólico e espiritual.",
      "O produto é destinado a maiores de 18 anos. As simpatias, rituais e reflexões descritos fazem parte de tradições populares e não substituem acompanhamento psicológico, médico ou profissional de qualquer natureza.",
      "Não há garantia de resultados amorosos ou de reconciliação. Qualquer reaproximação depende exclusivamente da vontade e das escolhas das pessoas envolvidas.",
      "Após a confirmação do pagamento, o acesso ao e-book é disponibilizado conforme o processo de entrega configurado na plataforma Monetizze.",
      "É proibida a reprodução, distribuição ou revenda do conteúdo do e-book sem autorização.",
    ],
  },
  contato: {
    title: "Contato",
    body: [
      "Para dúvidas sobre o e-book, sua compra ou o acesso ao material, utilize o canal de suporte abaixo.",
      "SUPPORT_PLACEHOLDER",
      "Se a sua dúvida for sobre pagamento, reembolso ou entrega, você também pode contatar o suporte da Monetizze diretamente pela área do comprador.",
    ],
  },
  "produto-digital": {
    title: "Informações sobre o Produto Digital",
    body: [
      "“Meu Ex de Volta — 50 Simpatias para Reconquistar um Amor” é um e-book digital em formato PDF, com 60 páginas de conteúdo.",
      "O material reúne 50 simpatias inspiradas em tradições populares, além de orações, reflexões espirituais e bônus especiais.",
      "Por se tratar de um produto digital, nenhum item físico é enviado. O acesso é disponibilizado após a confirmação do pagamento, conforme o processo de entrega configurado na Monetizze, e o arquivo pode ser aberto em celulares, tablets e computadores compatíveis com PDF.",
      "Este material possui finalidade cultural, simbólica e espiritual. Não oferece garantias de resultados amorosos ou de reconciliação.",
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const { settings } = useSettings();
  const content = PAGES[page] || PAGES.privacidade;

  return (
    <div className="min-h-screen bg-obsidian px-5 py-20 text-creme" data-testid={`legal-${page}`}>
      <div className="mx-auto max-w-2xl">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="text-xs uppercase tracking-[0.25em] text-rosa transition-colors hover:text-dourado"
        >
          ← Voltar para a página inicial
        </Link>
        <h1 className="mt-8 font-serif text-3xl font-semibold sm:text-4xl">
          <span className="gold-text">{content.title}</span>
        </h1>
        <div className="gold-line mt-6 w-24" />
        <div className="mt-8 space-y-5 text-base leading-relaxed text-creme/80">
          {content.body.map((p, i) =>
            p === "SUPPORT_PLACEHOLDER" ? (
              <p key={i} data-testid="legal-contato-valor">
                {settings.support_contact
                  ? `Suporte: ${settings.support_contact}`
                  : "O canal de suporte será informado em breve."}
              </p>
            ) : (
              <p key={i}>{p}</p>
            )
          )}
        </div>
      </div>
    </div>
  );
}
